import type { AllocationBarProps } from "./types-gantt-allocation-bar";
import { useGanttAllocationBar } from "./use-gantt-allocation-bar";
import { AllocationBarView } from "./view-gantt-allocation-bar";

export function AllocationBar(props: AllocationBarProps) {
  const vm = useGanttAllocationBar(props);

  return <AllocationBarView {...vm} />;
}

export type * from "./types-gantt-allocation-bar";
